/*
 * @Author: betwaym 848032671@qq.com
 * @Date: 2024-01-29 13:14:47
 * @LastEditors: betwaym 848032671@qq.com
 * @LastEditTime: 2024-01-29 13:27:39
 * @FilePath: \mrc-ess-base-frontend\src\utils\Ls.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Storage from "vue-ls";
const options = {
    namespace: "mrc-ess-base-", // key prefix
    name: "ls", // name variable Vue.[ls] or this.[$ls],
    storage: "local", // storage name session, local, memory
};
const { ls } = Storage.useStorage(options);
export default ls;
